'use strict';

var __assign =
  (void 0 && (void 0).__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

    return __assign.apply(this, arguments);
  };

var _a;

Object.defineProperty(exports, '__esModule', {
  value: true,
});

var components_1 = require('./components');

var lightTheme_1 = require('./lightTheme');

var darkTheme_1 = require('./darkTheme');

var themeFonts_1 = require('./themeFonts');

var spacing_1 = require('./spacing');

var themeComponents_1 = require('./themeComponents');

var basics = {
  fonts: themeFonts_1.themeFonts,
  spacing: spacing_1.themeSpacing,
  transitions: {
    easeInOut: '0.3s ease-in-out',
    cubicBezier: '0.3s cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },

  shape: components_1.SHAPES.rounded,
  components: {
    table: {
      size: themeComponents_1.TABLE_SIZE_PARAMS,
    },

    tree: {
      size: themeComponents_1.TREE_SIZE_PARAMS,
    },
  },
};

var theme =
  ((_a = {}),
  (_a[components_1.THEMES.light] = __assign(__assign({}, lightTheme_1.lightTheme), basics)),
  (_a[components_1.THEMES.dark] = __assign(__assign({}, darkTheme_1.darkTheme), basics)),
  _a);
exports.default = theme;
